import React from 'react';
import validator from 'validator';
import {validated} from 'react-custom-validation';
import classnames from 'classnames';
import {injectIntl} from 'react-intl';
import {Message} from '@aperza/react-ui';

class SendEmailForm extends React.Component {

  render() {
    const {fields, validations, serviceId, onChange, onValid, onInvalid, itemPageShown, $field} = this.props;
    const {formatMessage} = this.props.intl;

    let messageText;
    if (itemPageShown === false) {
      messageText = serviceId == 3 ? "clip.email.info.2.product" : (serviceId == 5 ? "clip.email.info.2.catalog" : "clip.email.info.2.article");
    }
    else {
      messageText = "clip.email.info.2.item";
    }

    return(
      <form>
        <div className="modal_title">
          <p><Message messageId="clip.email"/></p>
          <p className="modal_closeBtn"><span className="icon icon-close" onClick={this.props.closeMailClip}></span></p>
        </div>
        <div className="modal_body">
          <p className="catchCopyM"><Message messageId="clip.email.info.1"/></p>
          <p><Message messageId={messageText}/></p>
          <dl>
            <dt><Message messageId="clip.email.info.3"/></dt>
            <dd>
              <input
                ref="email"
                type="text"
                className={classnames({'input-error': validations.email.show && !validations.email.isValid})}
                placeholder={formatMessage({id: 'clip.email.placeholder'})}
                value={fields.email}
                {...$field(
                  'email',
                  (e) => onChange('email', e.target.value),
                  null,
                  10000
                )}/>
              {
                validations.email.show && !validations.email.isValid && <p className='errorText'>{validations.email.error.reason}</p>
              }
            </dd>
          </dl>
        </div>
        <div className="modal_footer">
          <p className="modal_submitBtn">
            <button className="btn btn-m btn-fill btn-txt-rev" onClick={(e) => {
              e.preventDefault();
              let that = this;
              this.props.$submit(
                () => onValid(that.refs.email.value),
                onInvalid)
            }} ><Message messageId="clip.send"/></button>
          </p>
        </div>
      </form>
    );
  }
}

const isEmail = (email) => validator.isEmail(email) ? null : "正しいメールアドレスを入力してください。";
const isNotEmpty = (email) => validator.isEmpty(email) == false ?  null : "正しいメールアドレスを入力してください。" ;

function validationConfig(props) {
  const {onValidation, fields: {email}} = props

  return {
    fields: ['email'],
    onValidation,
    validations: {
      email: [
        [isNotEmpty, email],
        [isEmail, email]
      ]
    },
  }
}

export default validated(validationConfig)(injectIntl(SendEmailForm));



// WEBPACK FOOTER //
// ./SendEmailForm.js